var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('p', {
    staticClass: "h5"
  }, [_vm._v("About")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-link', {
    staticClass: "locations-quicklink",
    attrs: {
      "tag": "div",
      "to": {
        path: '/contact#our-centers'
      }
    }
  }, [_vm._v("Our Locations")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/projects'
      }
    }
  }, [_vm._v("Galleries")]), _vm._v(" "), _c('router-link', {
    staticClass: "locations-quicklink",
    attrs: {
      "tag": "div",
      "to": {
        path: '/reports'
      }
    }
  }, [_vm._v("Annual Reports")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_vm._v("\n      © Copyright 2017 | Friends NGO | All Rights Reserved\n    ")])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('p', {
    staticClass: "h5"
  }, [_vm._v("Resources")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.who.int/countries/ind/en/"
    }
  }, [_vm._v("WHO")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.ukhfws.org/index.php "
    }
  }, [_vm._v("UKHFWS")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://naco.gov.in/"
    }
  }, [_vm._v("NACO")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('p', {
    staticClass: "h5 "
  }, [_vm._v("Miscellaneous")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://nhm.gov.in"
    }
  }, [_vm._v("National Health Mission")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.nhp.gov.in/"
    }
  }, [_vm._v("National Health Portal")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-450db851","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 2g6c
// module chunks = 0